import { useState, useEffect } from "react";

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";

//Common
import { ID_AUTORIZACAO } from "@/common/constantes";
import { fn_formatarDataHora } from "@/common/utils/date";

//Util
import { ICONES_BOTAO } from "@/frontend/utils/icones";
import { fn_formatarLog } from "@/frontend/utils/log";

//API
import { api_listar, ROTA_LISTAR } from "@/frontend/services/api/api_list";

//Telas
import SemRegistros from "@/frontend/pages/semRegistros";

function TSituacao_contrato_hist({
  modalOpen,
  toggleModal,
  solicitacao,
  //contrato,
}) {
  //### USE STATE ###
  const [logs, setLogs] = useState([]);

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega os logs de alteração da situação do contrato
    async function loadLogAlteracaoSituacao() {
      const logs = await api_listar(
        ROTA_LISTAR.AUTORIZACAO_LOG,
        `id_autorizacao=${ID_AUTORIZACAO.ALTERACAO_SITUACAO_CONTRATO}&model=Solicitacao&id_model=${solicitacao.id}&direacaoOrder=ASC`,
      );

      setLogs(logs);
    }

    loadLogAlteracaoSituacao();
  }, []);

  return (
    <Modal isOpen={modalOpen} backdrop="static" size="xl">
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        Histórico Alteração Situação Contrato
      </ModalHeader>

      <ModalBody>
        <div className="m-1 scroll-modal">
          <Table responsive>
            <thead>
              <tr>
                <td width="10%" className="table-header">
                  Data
                </td>
                <td width="25%" className="table-header">
                  Usuário
                </td>
                <td width="20%" className="table-header">
                  Situação
                </td>
                <td className="table-header">Motivo</td>
              </tr>
            </thead>

            <tbody>
              {logs.map((logAut, index) => (
                <tr
                  key={index}
                  className={
                    logs.length > 1 && index == logs.length - 1 ? "fw-bold" : ""
                  }
                >
                  <td>{fn_formatarDataHora(logAut.data)}</td>

                  <td>{logAut.usuario.nome}</td>
                  <td>
                    <div className="d-flex">
                      {fn_formatarLog(
                        logAut.log,
                        ["Situação atual"],
                        true, //somente valor
                      )}

                      <span className="ms-1 me-1">-&gt;</span>

                      {fn_formatarLog(
                        logAut.log,
                        ["Situação nova"],
                        true, //somente valor
                      )}
                    </div>
                  </td>

                  <td>{fn_formatarLog(logAut.log, ["Motivo"], true)}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          {logs.length == 0 && <SemRegistros />}
        </div>
      </ModalBody>

      <ModalFooter>
        <Button name="btnFechar" color="secondary" onClick={toggleModal}>
          {ICONES_BOTAO.FECHAR} Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default TSituacao_contrato_hist;
